import { render } from "./TextCopier.vue?vue&type=template&id=3c113db8&scoped=true"
import script from "./TextCopier.vue?vue&type=script&lang=js"
export * from "./TextCopier.vue?vue&type=script&lang=js"

import "./TextCopier.vue?vue&type=style&index=0&id=3c113db8&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3c113db8"]])

export default __exports__